module.exports = __webpack_public_path__ + "static/media/brain.8d901513.png";